import styled from 'styled-components';

interface SearchBarProps {
  fullWidth?: boolean;
}

export const SearchBar: any = styled.div<SearchBarProps>`
  display: flex;
  padding: 0 16px;
  border-radius: 8px;
  flex-grow: 1;
  background-color: ${({ theme }) => theme.searchBar.background};

  @media ${({ theme }) => theme.device.desktop} {
    max-width: ${({ fullWidth }) => (fullWidth ? '100%' : '400px')};
  }
`;

SearchBar.InputContainer = styled.div`
  width: 100%;
`;

SearchBar.Input = styled.input`
  border: none;
  background: none;
  height: 40px;
  width: 100%;
`;

SearchBar.Icon = styled.img`
  margin-right: 14px;
`;

SearchBar.CloseSearch = styled.img`
  margin-left: 14px;
`;
